import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable()
export class LevelerGuard implements CanActivate {

  constructor(private authService: AuthService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this.authService.getUser();
                
    if (!user) {
      // navegar para pagina de login        
      this.authService.handleLogin();
      return false;
    }
           
    
    if (next.data.isLeveler.toUpperCase() === user.isLeveler.toUpperCase())
      return true;
        
    // navegar para pagina de login   
    this.authService.handleLogin('/teacher/scheduler');
    return false;
  }
}